import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing product types.
 */
interface ListProductTypesRequest {
  queryKey: [number, string, string];
}

/**
 * Service class for handling products types.
 */
class ProductTypeService {
  static listProductTypes(request: ListProductTypesRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];
    const status = request.queryKey[2];
    return client.get(
      `admin/product-type/list?page=${page_no}&search_text=${searchText}&status=${status}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new product types based on the provided request.
   *
   * @param request - The request parameters for adding a product types.
   * @returns A Promise that resolves to the Axios response for the add product types request.
   */
  static addProductTypes(request: any) {
    return client.post("admin/product-type/add", request);
  }

  /**
   * Updates the status of a product types based on the provided request.
   *
   * @param request - The request parameters for updating the status of a product types.
   * @returns A Promise that resolves to the Axios response for the update status request.
   */
  static updateStatusProductTypes(request: any) {
    return client.patch("admin/product-type/update-status/", request);
  }

  /**
   * Updates the details of a product types based on the provided request.
   *
   * @param request - The request parameters for updating a product types.
   * @returns A Promise that resolves to the Axios response for the update product types request.
   */
  static updateProductTypes(request: any) {
    return client.post("admin/product-type/edit/", request);
  }

  /**
   * Retrieves the details of a product types based on the provided parameters.
   *
   * @param params - The parameters for retrieving the product types details.
   * @returns A Promise that resolves to the Axios response containing the product types details.
   */
  static viewProductTypes(params: any) {
    return client.get("admin/product-type/get", { params });
  }

  /**
   * Deletes a product types based on the provided parameters.
   *
   * @param params - The parameters for deleting the product types.
   * @returns A Promise that resolves to the Axios response for the delete product types request.
   */
  static deleteProductTypes(params: any) {
    return client.delete("/admin/product-type/delete/", { params });
  }

  /**
   * get Product type Details based on the provided request.
   *
   * @param request - The request parameters for getting a product type.
   * @returns A Promise that resolves to the Axios response for the update product type request.
   */
  static getProductTypeList(request: any) {
    return client.get("admin/product-type/get-product-type-list/", request);
  }
}

export { ProductTypeService };
